import { render, staticRenderFns } from "./NavigationPath.vue?vue&type=template&id=4aba52ea"
import script from "./NavigationPath.vue?vue&type=script&lang=js"
export * from "./NavigationPath.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports